import { GenericAggregateResponse } from "./generic-types";

export async function handleNonOkExportResponse<
  T extends GenericAggregateResponse
>(apiResponse: Response, response: T) {
  if (apiResponse.status === 401) {
    response.noAccessRights = true;
    return response;
  }
  if (apiResponse.status === 404 || apiResponse.status === 500) {
    response.serverError = true;
    return response;
  }
  if (apiResponse.status === 403) {
    const statusText = (await apiResponse.json()).detail;
    if (statusText === "You are not authorized to see this client") {
      response.noClientMapping = true;
    } else {
      response.noAccessRights = true;
    }
    response.statusText = statusText;
    return response;
  }
  return response;
}
export async function handleBlob(apiResponse: Response, filename: string) {
  const blobData = await apiResponse.blob();
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blobData, filename);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blobData);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  return blobData;
}

export function htmlToExcel(table: any, name: string) {
  const uri = "data:application/vnd.ms-excel;charset=UTF-8;base64,";
  const template =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' +
    'xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;' +
    'charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
    "{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>" +
    "</x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>";
  const base64 = (s: any) => {
    return window.btoa(unescape(encodeURIComponent(s)));
  };
  const format = (s: any, c: any) => {
    return s.replace(/{(\w+)}/g, (m: any, p: any) => {
      return c[p];
    });
  };
  const ctx = {
    table: table.innerHTML,
    worksheet: name,
  };
  const href = uri + base64(format(template, ctx));
  const link = document.createElement("a");
  link.href = href;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export class GenericExportBackgroundResponse extends GenericAggregateResponse {
  public fileId: string;
  /**
   *
   */
  constructor() {
    super();
    this.fileId = "";
  }
}
